import React, { useState, useEffect } from 'react';
import { ref, get, push, set, update, remove } from 'firebase/database';
import { database } from '../firebase/config';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import PulsantiCondivisionePDF from './PulsantiCondivisionePDF';
import '../styles/Liste.css';
import { formattaData } from '../utils/dateUtils'; 
import { useFirebaseData } from '../hooks/useFirebaseData';

// Stili per il PDF del report veicolo
const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica'
  },
  header: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center',
    color: '#2c3e50',
    fontWeight: 'bold'
  },
  subheader: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: '#7f8c8d'
  },
  infoBox: {
    backgroundColor: '#e3f2fd',
    padding: 10,
    marginBottom: 15,
    borderRadius: 5
  },
  infoText: {
    fontSize: 11,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 10
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dee2e6',
    minHeight: 25,
    alignItems: 'center'
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    fontSize: 9
  },
  tableCol: {
    padding: 5,
    fontSize: 8
  },
  col1: { width: '10%' },
  col2: { width: '10%' },
  col3: { width: '8%' },
  col4: { width: '8%' },
  col5: { width: '8%' },
  col6: { width: '16%' },
  col7: { width: '16%' },
  col8: { width: '24%' },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 8,
    color: '#95a5a6'
  }
});


function ListaVeicoli() {
  const { dipendenti, cantieri, clienti,
    caricaDipendenti, caricaCantieri, caricaClienti
  } = useFirebaseData()
  const [veicoli, setVeicoli] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    marca: '',
    modello: '',
    targa: '',
    costoOrario: '',
    costoKm: ''
  });

  const [showReportModal, setShowReportModal] = useState(false);
  const [veicoloSelezionato, setVeicoloSelezionato] = useState(null);
  const [programmiVeicolo, setProgrammiVeicolo] = useState([]);
  const [ordinamentoReport, setOrdinamentoReport] = useState({
    campo: 'data',
    direzione: 'desc'
  });

  useEffect(() => {
    caricaVeicoli();
  }, []);

  async function caricaVeicoli() {
    const veicoliRef = ref(database, 'veicoli');
    const snapshot = await get(veicoliRef);
    
    if (snapshot.exists()) {
      const data = snapshot.val();
      const veicoliArray = Object.keys(data).map(key => ({
        id: key,
        ...data[key]
      }));
      setVeicoli(veicoliArray);
    } else {
      setVeicoli([]);
    }
  }

  function apriModal(veicolo = null) {
    if (veicolo) {
      setEditingId(veicolo.id);
      setFormData({
        marca: veicolo.marca || '',
        modello: veicolo.modello || '',
        targa: veicolo.targa || '',
        costoOrario: veicolo.costoOrario != null ? String(veicolo.costoOrario) : '',
        costoKm: veicolo.costoKm != null ? String(veicolo.costoKm) : ''
      });
    } else {
      setEditingId(null);
      setFormData({
        marca: '',
        modello: '',
        targa: '',
        costoOrario: '',
        costoKm: ''
      });
    }
    setShowModal(true);
  }

  function chiudiModal() {
    setShowModal(false);
    setEditingId(null);
    setFormData({
      marca: '',
      modello: '',
      targa: '',
      costoOrario: '',
      costoKm: ''
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!formData.marca || !formData.modello || !formData.targa) {
      alert('Compila tutti i campi');
      return;
    }

    try {
      if (editingId) {
        const veicoloRef = ref(database, `veicoli/${editingId}`);
        await update(veicoloRef, {
          marca: formData.marca,
          modello: formData.modello,
          targa: formData.targa.toUpperCase(),
          costoOrario: formData.costoOrario !== '' ? Number(formData.costoOrario) : null,
          costoKm: formData.costoKm !== '' ? Number(formData.costoKm) : null
        });
        alert('Veicolo modificato con successo!');
      } else {
        const veicoliRef = ref(database, 'veicoli');
        const newVeicoloRef = push(veicoliRef);
        await set(newVeicoloRef, {
          marca: formData.marca,
          modello: formData.modello,
          targa: formData.targa.toUpperCase(),
          costoOrario: formData.costoOrario !== '' ? Number(formData.costoOrario) : null,
          costoKm: formData.costoKm !== '' ? Number(formData.costoKm) : null,
          createdAt: Date.now()
        });
        alert('Veicolo creato con successo!');
      }
      
      chiudiModal();
      caricaVeicoli();
    } catch (error) {
      alert('Errore: ' + error.message);
    }
  }

  async function eliminaVeicolo(id, marca, modello, targa) {
    if (window.confirm(`Sei sicuro di voler eliminare ${marca} ${modello} (${targa})?`)) {
      try {
        const veicoloRef = ref(database, `veicoli/${id}`);
        await remove(veicoloRef);
        alert('Veicolo eliminato!');
        caricaVeicoli();
      } catch (error) {
        alert('Errore: ' + error.message);
      }
    }
  }


  async function apriReportVeicolo(veicolo) {
    setVeicoloSelezionato(veicolo);
    setShowReportModal(true);
    
    await Promise.all([
      caricaProgrammiVeicolo(veicolo.id),
      caricaDipendenti(),
      caricaCantieri(),
      caricaClienti()
    ]);
  }

  async function caricaProgrammiVeicolo(veicoloId) {
    try {
      const programmiRef = ref(database, 'programmi-lavorativi');
      const snapshot = await get(programmiRef);
      
      if (snapshot.exists()) {
        const data = snapshot.val();
        const programmiArray = Object.keys(data)
          .map(key => ({ id: key, ...data[key] }))
          .filter(prog => prog.veicoloId === veicoloId)
          .sort((a, b) => new Date(b.data) - new Date(a.data));
        
        setProgrammiVeicolo(programmiArray);
      } else {
        setProgrammiVeicolo([]);
      }
    } catch (error) {
      console.error('Errore caricamento programmi:', error);
      setProgrammiVeicolo([]);
    }
  }


  function chiudiReportModal() {
    setShowReportModal(false);
    setVeicoloSelezionato(null);
    setProgrammiVeicolo([]);
  }

  function getDipendente(id) {
    return dipendenti.find(d => d.id === id);
  }

  function getCantiere(id) {
    return cantieri.find(c => c.id === id);
  }

  function getCliente(cantiereId) {
    const cantiere = getCantiere(cantiereId);
    return cantiere ? clienti.find(c => c.id === cantiere.clienteId) : null;
  }

  function handleOrdinamentoReport(campo) {
    let direzione = 'asc';
    
    if (ordinamentoReport.campo === campo && ordinamentoReport.direzione === 'asc') {
      direzione = 'desc';
    }
    
    setOrdinamentoReport({ campo, direzione });
  }

  function getProgrammiOrdinati() {
    const programmiCopia = [...programmiVeicolo];
    
    programmiCopia.sort((a, b) => {
      let valoreA, valoreB;
      
      if (ordinamentoReport.campo === 'data') {
        valoreA = new Date(a.data);
        valoreB = new Date(b.data);
      } else if (ordinamentoReport.campo === 'dipendente') {
        const dipA = getDipendente(a.dipendenteId);
        const dipB = getDipendente(b.dipendenteId);
        valoreA = dipA ? dipA.cognome.toLowerCase() : '';
        valoreB = dipB ? dipB.cognome.toLowerCase() : '';
      } else if (ordinamentoReport.campo === 'cliente') {
        const cliA = getCliente(a.cantiereId);
        const cliB = getCliente(b.cantiereId);
        valoreA = cliA ? cliA.ragioneSociale.toLowerCase() : '';
        valoreB = cliB ? cliB.ragioneSociale.toLowerCase() : '';
      } else if (ordinamentoReport.campo === 'cantiere') {
        const cantA = getCantiere(a.cantiereId);
        const cantB = getCantiere(b.cantiereId);
        valoreA = cantA ? cantA.luogo.toLowerCase() : '';
        valoreB = cantB ? cantB.luogo.toLowerCase() : '';
      }
      
      if (valoreA < valoreB) {
        return ordinamentoReport.direzione === 'asc' ? -1 : 1;
      }
      if (valoreA > valoreB) {
        return ordinamentoReport.direzione === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
    return programmiCopia;
  }

  function getFrecciaReport(campo) {
    if (ordinamentoReport.campo !== campo) {
      return '↕️';
    }
    return ordinamentoReport.direzione === 'asc' ? '🔼' : '🔽';
  }

  const ReportVeicoloPDF = ({ veicolo, programmi }) => (
    <Document>
      <Page size="A4" orientation="landscape" style={pdfStyles.page}>
        <Text style={pdfStyles.header}>Report Programmi Lavorativi - Veicolo</Text>
        <Text style={pdfStyles.subheader}>
          {veicolo.marca} {veicolo.modello} - {veicolo.targa}
        </Text>
        
        <View style={pdfStyles.infoBox}>
          <Text style={pdfStyles.infoText}>
            Totale Programmi: {programmi.length}
          </Text>
        </View>

        <View style={pdfStyles.table}>
          <View style={[pdfStyles.tableRow, pdfStyles.tableHeader]}>
            <Text style={[pdfStyles.tableCol, pdfStyles.col1]}>Data</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col2]}>Dipendente</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col3]}>Inizio</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col4]}>Fine</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col5]}>Durata</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col6]}>Cliente</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col7]}>Cantiere</Text>
            <Text style={[pdfStyles.tableCol, pdfStyles.col8]}>Note</Text>
          </View>

          {programmi.map((prog, index) => {
            const dipendente = getDipendente(prog.dipendenteId);
            const cantiere = getCantiere(prog.cantiereId);
            const cliente = getCliente(prog.cantiereId);

            return (
              <View key={index} style={pdfStyles.tableRow}>
                <Text style={[pdfStyles.tableCol, pdfStyles.col1]}>{formattaData(prog.data)}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col2]}>
                  {dipendente ? `${dipendente.nome} ${dipendente.cognome}` : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col3]}>{prog.orarioInizio}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col4]}>{prog.orarioFine}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col5]}>{prog.durataLavoro}</Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col6]}>
                  {cliente ? cliente.ragioneSociale : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col7]}>
                  {cantiere ? cantiere.luogo : 'N/D'}
                </Text>
                <Text style={[pdfStyles.tableCol, pdfStyles.col8]}>
                  {prog.note || '-'}
                </Text>
              </View>
            );
          })}
        </View>

        <Text style={pdfStyles.footer}>
          Report generato il {new Date().toLocaleDateString('it-IT')} alle {new Date().toLocaleTimeString('it-IT')}
        </Text>
      </Page>
    </Document>
  );


  return (
    <div className="lista-container">
      <div className="lista-header">
        <h2>🚚 Gestione mezzi lavoro</h2>
        <button className="btn-add" onClick={() => apriModal()}>
          + Aggiungi mezzo
        </button>
      </div>

      {veicoli.length === 0 ? (
        <div className="empty-state">
          <p>Nessun veicolo presente.</p>
          <p>Clicca su "Aggiungi Veicolo" per iniziare.</p>
        </div>
      ) : (
        <>
          {/* Tabella Desktop */}
          <table className="data-table">
            <thead>
              <tr>
                <th>Marca</th>
                <th>Modello</th>
                <th>Targa</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {veicoli.map(veicolo => (
                <tr key={veicolo.id}>
                  <td>{veicolo.marca}</td>
                  <td>{veicolo.modello}</td>
                  <td><strong>{veicolo.targa}</strong></td>
                  <td className="actions">
                    <button 
                      className="btn-edit"
                      onClick={() => apriReportVeicolo(veicolo)}
                      style={{background: '#9b59b6'}}
                    >
                      <img src="/icon-report.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                    <button 
                      className="btn-edit"
                      onClick={() => apriModal(veicolo)}
                    >
                      <img src="/icon-edit.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                    <button 
                      className="btn-delete"
                      onClick={() => eliminaVeicolo(veicolo.id, veicolo.marca, veicolo.modello, veicolo.targa)}
                    >
                      <img src="/icon-delete.svg" alt="pdf" style={{ width: '40px' }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Layout Card Mobile */}
          <div className="mobile-cards">
            {veicoli.map(veicolo => (
              <div key={veicolo.id} className="mobile-card">
                <div className="mobile-card-header">
                  🚚 {veicolo.marca} {veicolo.modello}
                </div>
                
                <div className="mobile-card-row">
                  <span className="mobile-card-label">Targa:</span>
                  <span className="mobile-card-value"><strong>{veicolo.targa}</strong></span>
                </div>
                
                <div className="mobile-card-actions">
                  <button 
                    className="btn-edit"
                    onClick={() => apriReportVeicolo(veicolo)}
                    style={{background: '#9b59b6'}}
                  >
                    <img src="/icon-report.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                  <button 
                    className="btn-edit"
                    onClick={() => apriModal(veicolo)}
                  >
                    <img src="/icon-edit.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                  <button 
                    className="btn-delete"
                    onClick={() => eliminaVeicolo(veicolo.id, veicolo.marca, veicolo.modello, veicolo.targa)}
                  >
                    <img src="/icon-delete.svg" alt="pdf" style={{ width: '40px' }} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}


      {showModal && (
        <div className="modal-overlay" onClick={chiudiModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{editingId ? 'Modifica Veicolo' : 'Nuovo Veicolo'}</h3>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Marca *</label>
                <input
                  type="text"
                  value={formData.marca}
                  onChange={(e) => setFormData({...formData, marca: e.target.value})}
                  placeholder="es. Fiat, Ford, Mercedes"
                  required
                />
              </div>

              <div className="form-group">
                <label>Modello *</label>
                <input
                  type="text"
                  value={formData.modello}
                  onChange={(e) => setFormData({...formData, modello: e.target.value})}
                  placeholder="es. Ducato, Transit, Sprinter"
                  required
                />
              </div>

              <div className="form-group">
                <label>Targa *</label>
                <input
                  type="text"
                  value={formData.targa}
                  onChange={(e) => setFormData({...formData, targa: e.target.value})}
                  placeholder="es. AB123CD"
                  required
                  maxLength="10"
                />
              </div>

              <div className="form-group">
                <label>Costo orario (CHF)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={formData.costoOrario}
                  onChange={(e) => setFormData({...formData, costoOrario: e.target.value})}
                  placeholder="es. 85.00"
                />
              </div>

              <div className="form-group">
                <label>Costo per km (CHF)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={formData.costoKm}
                  onChange={(e) => setFormData({...formData, costoKm: e.target.value})}
                  placeholder="es. 1.20"
                />
              </div>


              <div className="modal-buttons">
                <button type="button" className="btn-cancel" onClick={chiudiModal}>
                  Annulla
                </button>
                <button type="submit" className="btn-save">
                  {editingId ? 'Salva Modifiche' : 'Crea Veicolo'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Report Veicolo */}
      {showReportModal && veicoloSelezionato && (
        <div className="modal-overlay" onClick={chiudiReportModal}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={{maxWidth: '90%', maxHeight: '90vh', overflow: 'auto'}}
          >
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px'}}>
              <h3 style={{margin: 0}}>📊 Report Programmi - {veicoloSelezionato.marca} {veicoloSelezionato.modello} ({veicoloSelezionato.targa})</h3>
              <button 
                onClick={chiudiReportModal}
                style={{
                  background: '#95a5a6',
                  border: 'none',
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
              >
                ✕
              </button>
            </div>

            {programmiVeicolo.length === 0 ? (
              <div style={{textAlign: 'center', padding: '40px', color: '#7f8c8d'}}>
                <p>Nessun programma lavorativo trovato per questo veicolo.</p>
              </div>
            ) : (
              <>
                {/* 👇 Riga gialla con bottone PDF */}
                <div style={{
                  background: '#efd400',
                  padding: '15px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}>
                  <strong>Totale programmi: {programmiVeicolo.length}</strong>
                  
                  <PulsantiCondivisionePDF
                    documentoPDF={<ReportVeicoloPDF veicolo={veicoloSelezionato} programmi={getProgrammiOrdinati()} />}
                    nomeFile={`Report_Veicolo_${veicoloSelezionato.marca}_${veicoloSelezionato.modello}_${veicoloSelezionato.targa}.pdf`}
                    testoCondivisione={`📊 Report Programmi Veicolo\n\n🚚 ${veicoloSelezionato.marca} ${veicoloSelezionato.modello}\n🔖 ${veicoloSelezionato.targa}\n📋 ${programmiVeicolo.length} utilizzi totali`}
                    emailDestinatario=""
                    oggettoEmail={`Report Veicolo - ${veicoloSelezionato.marca} ${veicoloSelezionato.modello} (${veicoloSelezionato.targa})`}
                    corpoEmail={`Buongiorno,\n\nallego il report completo degli utilizzi del veicolo:\n\nVEICOLO: ${veicoloSelezionato.marca} ${veicoloSelezionato.modello}\nTARGA: ${veicoloSelezionato.targa}\nTOTALE UTILIZZI: ${programmiVeicolo.length}\n\nCordiali saluti`}
                  />
                </div>

                {/* 👇 TABELLA DESKTOP (nascosta su mobile) */}
                <div style={{overflowX: 'auto'}} className="desktop-only">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th 
                          onClick={() => handleOrdinamentoReport('data')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Data {getFrecciaReport('data')}
                        </th>
                        <th 
                          onClick={() => handleOrdinamentoReport('dipendente')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Dipendente {getFrecciaReport('dipendente')}
                        </th>
                        <th>Orario Inizio</th>
                        <th>Orario Fine</th>
                        <th>Durata</th>
                        <th 
                          onClick={() => handleOrdinamentoReport('cliente')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Cliente {getFrecciaReport('cliente')}
                        </th>
                        <th 
                          onClick={() => handleOrdinamentoReport('cantiere')}
                          style={{cursor: 'pointer', userSelect: 'none'}}
                        >
                          Cantiere {getFrecciaReport('cantiere')}
                        </th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getProgrammiOrdinati().map(prog => {
                        const dipendente = getDipendente(prog.dipendenteId);
                        const cantiere = getCantiere(prog.cantiereId);
                        const cliente = getCliente(prog.cantiereId);

                        return (
                          <tr key={prog.id}>
                            <td><strong>{formattaData(prog.data)}</strong></td>
                            <td>
                              {dipendente ? (
                                <>
                                  {dipendente.nome} {dipendente.cognome}
                                </>
                              ) : 'N/D'}
                            </td>
                            <td>{prog.orarioInizio}</td>
                            <td>{prog.orarioFine}</td>
                            <td><strong>{prog.durataLavoro}</strong></td>
                            <td>{cliente ? cliente.ragioneSociale : 'N/D'}</td>
                            <td>{cantiere ? cantiere.luogo : 'N/D'}</td>
                            <td style={{maxWidth: '200px', fontSize: '12px'}}>
                              {prog.note || '-'}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* 👇 LAYOUT CARD MOBILE (nascosto su desktop) */}
                <div className="mobile-cards">
                  {getProgrammiOrdinati().map(prog => {
                    const dipendente = getDipendente(prog.dipendenteId);
                    const cantiere = getCantiere(prog.cantiereId);
                    const cliente = getCliente(prog.cantiereId);

                    return (
                      <div key={prog.id} className="mobile-card">
                        <div className="mobile-card-header">
                          📅 {formattaData(prog.data)}
                        </div>
                        
                        <div className="mobile-card-row">
                          <span className="mobile-card-label">👤 Dipendente:</span>
                          <span className="mobile-card-value">
                            {dipendente ? `${dipendente.nome} ${dipendente.cognome}` : 'N/D'}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🕐 Orario:</span>
                          <span className="mobile-card-value">
                            {prog.orarioInizio} - {prog.orarioFine}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">⏱️ Durata:</span>
                          <span className="mobile-card-value">
                            <strong>{prog.durataLavoro}</strong>
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🏢 Cliente:</span>
                          <span className="mobile-card-value">
                            {cliente ? cliente.ragioneSociale : 'N/D'}
                          </span>
                        </div>

                        <div className="mobile-card-row">
                          <span className="mobile-card-label">🏗️ Cantiere:</span>
                          <span className="mobile-card-value">
                            {cantiere ? cantiere.luogo : 'N/D'}
                          </span>
                        </div>

                        {prog.note && (
                          <div className="mobile-card-row">
                            <span className="mobile-card-label">📝 Note:</span>
                            <span className="mobile-card-value" style={{fontSize: '12px'}}>
                              {prog.note}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ListaVeicoli;
